import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { TrustSection } from './components/TrustSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background font-sans antialiased text-foreground" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <Features data-id="element-5" />
        <TrustSection data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}